import { STORE_COURSE_STRUCTURE, STORE_CONTENT_ITEMS, STORE_COURSE_TITLE} from '../constants/actionConstants';


// courseStructure -- the structure of the current course
// contentItems -- all of the content items in the database (for editing)

const CourseStructureReducer =  (state = {courseStructure: [], contentItems: [], courseTitle:""}, action) =>{
    switch(action.type)
    {

        // Fetch just the course structure for editing
        case STORE_COURSE_STRUCTURE:
            return {...state, 
                courseStructure: action.payload,
            }

        case STORE_COURSE_TITLE:
            return {...state, 
                courseTitle: action.payload,
            }
    
        // Stores all content items
        case STORE_CONTENT_ITEMS:
            return {...state, 
                contentItems: action.payload,
            }
        default:
            return state ; 
    }
} ; 

export default CourseStructureReducer 